<script>
import BaseButton from '../_base-button.vue'
import BaseIcon from '../_base-icon.vue'

export default {
    name: 'InAppBrowserModal',

    components: {
        BaseButton,
        BaseIcon,
    },

    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            url: this.data.url || window.location.href,
        }
    },

    methods: {
        close() {
            this.$emit('close')
        },
        openExternal() {
            window.location.href = `x-web-search://?${this.url}`
            window.open(this.url, '_blank')
            this.close()
        },
    },
}
</script>

<template>
    <div :class="$style.modal">
        <button
            :class="$style.closeButton"
            aria-label="Close modal"
            @click="close"
        >
            <BaseIcon
                :class="$style.closeIcon"
                name="close-outline"
            />
        </button>

        <div :class="$style.content">
            <h2 :class="$style.headline">
                Enjoy the best FRISKY experience
            </h2>
            <p :class="$style.description">
                For the best experience, please open this link in your device's default browser.
            </p>

            <div :class="$style.actions">
                <BaseButton
                    :class="$style.primaryButton"
                    size="large"
                    button-type="primaryFlat"
                    @click="openExternal"
                >
                    Open Link
                </BaseButton>
            </div>

            <div :class="$style.instructions">
                <p><strong>If the link doesn't open:</strong></p>
                <ol :class="$style.instructionsList">
                    <li>
                        Tap <span :class="$style.optionsButton">&#8230;</span> (options menu)
                    </li>
                    <li>
                        Select <strong>Open in External Browser</strong>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<style module lang="scss">
@use '@design' as *;

.modal {
    position: relative;
    background: #27292D;
    border-radius: 12px;
    padding: $s-h 64px 48px;
    width: 90vw;
    max-width: 710px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.95);
    border: none;

    @include mobileOnly {
        width: calc(100vw - $s-xxl);
        height: auto;
        max-width: none;
        border-radius: $s-m;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: $s-xxl 30px 36px;
        margin: $s-l;
    }
}

.closeButton {
    position: absolute;
    top: $s-l;
    right: $s-l;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    padding: $s-xxs;
    border-radius: 50%;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;

    .closeIcon {
        width: 20px;
        height: 20px;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.08);
    }

    @include mobileOnly {
        top: $s-l;
        right: $s-l;
    }
}

.content {
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

.headline {
    color: $c-white;
    margin: 0;
    margin-bottom: $s-xl;
    line-height: 1.2;
    font-size: 28px;
    font-weight: 700;
    font-family: aktiv-grotesk-extended, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
    letter-spacing: -0.03em;
    text-align: left;

    @include mobileOnly {
        font-size: $s-xl;
        margin-bottom: $s-l;
    }
}

.description {
    @extend %p;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 32px 0;
    font-size: $s-m;
    line-height: 1.5;
    text-align: left;

    @include mobileOnly {
        margin-bottom: $s-xl;
        font-size: 14px;
    }
}

.actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
    margin-bottom: 32px;
    width: 100%;

    @include mobileOnly {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: $s-m;
        margin-bottom: $s-xl;
        flex-wrap: wrap;
    }
}

.primaryButton {
    width: 100%;
    max-width: 400px;
    font-size: $s-m;
    padding: $s-l 36px;
    border-radius: 50px;
    text-transform: none;
    letter-spacing: normal;

    @include mobileOnly {
        width: auto;
        flex: 0 0 auto;
        padding: $s-m 28px;
    }
}

.instructions {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    line-height: 1.5;

    p {
        margin: 0 0 $s-s 0;
    }

    strong {
        color: rgba(255, 255, 255, 0.8);
    }

    @include mobileOnly {
        font-size: 13px;
    }
}

.instructionsList {
    list-style: decimal inside;
    padding: 0;
    margin: 0;

    li {
        margin-bottom: $s-xs;
    }
}

.optionsButton {
    padding: 2px $s-xs;
    background: $c-nevada-grey;
    color: $c-white;
    border-radius: 4px;
    font-family: monospace;
    font-weight: bold;
}
</style>
